/* ===================================== */
/* SHARE BUTTON */
/* ===================================== */

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.share-button');
  if (!btn) return;

  const data = { title: document.title, url: location.href };

  if (navigator.share) {
    navigator.share(data).catch(() => {});
  } else if (navigator.clipboard) {
    navigator.clipboard.writeText(location.href).then(() => {
      alert('Link copiado!');
    });
  }
});

/* ===================================== */
/* GLOBAL SHOPIFY DIALOG SCROLL FIX */
/* ===================================== */

(function () {

  const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  if (!isTouch) return;

  const DIALOG_SELECTOR = 'dialog[scroll-lock]';

  function restoreScroll() {

    const y = parseInt(document.body.dataset.scrollY || 0, 10);

    document.documentElement.style.overflow =
    document.body.style.overflow =
    document.body.style.position =
    document.body.style.top = '';

    document.body.classList.remove(
      'overflow-hidden',
      'modal-open',
      'js-modal-open'
    );

    if (y) {
      window.scrollTo(0, y);
      delete document.body.dataset.scrollY;
    }
  }

  function getOpenDialog() {
    return document.querySelector(`${DIALOG_SELECTOR}[open]`);
  }

  function closeDialog(dialog) {
    if (!dialog) return;
    if (dialog.hasAttribute('open')) dialog.close();
    restoreScroll();
  }

  /* Intercepta fechamento normal */
  document.addEventListener('close', function (e) {
    if (e.target.matches(DIALOG_SELECTOR)) {
      restoreScroll();
    }
  }, true);

  /* Observer único */
const observer = new MutationObserver(() => {
  if (!getOpenDialog()) {
    requestAnimationFrame(
      restoreScroll
    );
  }
});

observer.observe(
  document.body,
  {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['open']
  }
);

  /* Gesture back mobile */
  window.addEventListener('popstate', function () {
    const dialog = getOpenDialog();
    if (!dialog) return;
    closeDialog(dialog);
  });

})();


/* ===================================== */
/* FIX ESTRELINHAS GO TO AVALIAÇÕES */
/* ===================================== */

window.addEventListener('load', () => {

  document.body.addEventListener('click', e => {

    const badge =
      e.target.closest('.jdgm-prev-badge') ||
      e.target.closest('.jdgm-prev-badge__stars') ||
      e.target.closest('.jdgm-prev-badge__text');

    if (!badge) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const target = document.querySelector('.depoimentos-secao');

    if (!target) return;

    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });

  }, true);

});